<template>
  <div class="grid grid-cols-2 gap-2 rounded-2xl bg-[#FFF4EA] p-1.5">
    <component
      :is="leftTag"
      :to="leftTo"
      type="button"
      class="auth-tab text-center"
      :class="{ 'auth-tab-active': activeRole === leftRole }"
      @click="emitSelect(leftRole)"
    >
      {{ leftLabel }}
    </component>
    <component
      :is="rightTag"
      :to="rightTo"
      type="button"
      class="auth-tab text-center"
      :class="{ 'auth-tab-active': activeRole === rightRole }"
      @click="emitSelect(rightRole)"
    >
      {{ rightLabel }}
    </component>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'

const props = defineProps({
  activeRole: {
    type: String,
    required: true
  },
  leftRole: {
    type: String,
    default: 'user'
  },
  leftLabel: {
    type: String,
    default: 'User'
  },
  leftTo: {
    type: String,
    default: ''
  },
  rightRole: {
    type: String,
    default: 'vendor'
  },
  rightLabel: {
    type: String,
    default: 'Vendor'
  },
  rightTo: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['select'])

const leftTag = props.leftTo ? 'RouterLink' : 'button'
const rightTag = props.rightTo ? 'RouterLink' : 'button'

const emitSelect = (role) => {
  if (!props.leftTo && role === props.leftRole) emit('select', role)
  if (!props.rightTo && role === props.rightRole) emit('select', role)
}
</script>

<style scoped>
.auth-tab {
  border: 0;
  border-radius: 16px;
  background: transparent;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 700;
  color: #6b7280;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.auth-tab-active {
  background: #ffffff;
  color: #1f2937;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}
</style>
